module.exports = __webpack_public_path__ + "static/media/RI-D5-5.3-042.655eac71.webp";